import React from 'react';
import { Spinner } from 'react-bootstrap';

import styles from './Loader.module.scss';

const Loader = () => {
    return (
        <div className={styles.loaderContainer}>
            <Spinner
                animation="border"
                role="status"
                className={styles.loader}
            >
                <span className="visually-hidden">Carregando...</span>
            </Spinner>
        </div>
    );
};

export default Loader;
